import { Tabs } from "@jhool-io/fe-components";
import { useSearchParams } from "react-router-dom";
import ProviderSessionActivity from "../ProviderSessionActivity/ProviderSessionActivity";
import ProviderAccommodationsList from "../ProviderAccommodationsList/ProviderAccommodationsList";
import { useDoesUserHavePermission } from "../../../../hooks/permissions";
import { UserPermisions } from "../../../../utils/types/user";

export default function ProviderSessionActivityWrapper() {
    const [searchParams, setSearchParams] = useSearchParams();

    const canViewAccommodations = useDoesUserHavePermission([
        UserPermisions.PROVIDER_ACCOMMODATION_READ,
    ]);

    const tabInUrl = searchParams.get("tab");

    const handleSetTabInUrl = (tab: string) => {
        setSearchParams({ tab });
    };

    const tabItems = [
        {
            key: "session_activity",
            label: "Session activity",
            children: <ProviderSessionActivity />,
            onClick: () => handleSetTabInUrl("session_activity"),
        },
        {
            key: "accommodations",
            label: "Accommodations",
            children: <ProviderAccommodationsList />,
            onClick: () => handleSetTabInUrl("accommodations"),
        },
    ];

    return canViewAccommodations ? (
        <Tabs
            items={tabItems}
            defaultActiveKey={tabInUrl || "session_activity"}
        />
    ) : (
        <ProviderSessionActivity />
    );
}
